import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["mode"];
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { collisionVelocity, getDistances, getRandom, getRangeMax, getRangeMin, getRangeValue, getValue, randomInRange } from "./NumberUtils";
import { Vector } from "../Core/Utils/Vector";
var _logger = {
  debug: console.debug,
  error: console.error,
  info: console.info,
  log: console.log,
  verbose: console.log,
  warning: console.warn
};
export function setLogger(logger) {
  _logger.debug = logger.debug || _logger.debug;
  _logger.error = logger.error || _logger.error;
  _logger.info = logger.info || _logger.info;
  _logger.log = logger.log || _logger.log;
  _logger.verbose = logger.verbose || _logger.verbose;
  _logger.warning = logger.warning || _logger.warning;
}
export function getLogger() {
  return _logger;
}

function rectSideBounce(data) {
  var res = {
    bounced: false
  },
      pSide = data.pSide,
      pOtherSide = data.pOtherSide,
      rectSide = data.rectSide,
      rectOtherSide = data.rectOtherSide,
      velocity = data.velocity,
      factor = data.factor;

  if (pOtherSide.min < rectOtherSide.min || pOtherSide.min > rectOtherSide.max || pOtherSide.max < rectOtherSide.min || pOtherSide.max > rectOtherSide.max) {
    return res;
  }

  if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) / 2 && velocity > 0 || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) / 2 && velocity < 0) {
    res.velocity = velocity * -factor;
    res.bounced = true;
  }

  return res;
}

function checkSelector(element, selectors) {
  var res = executeOnSingleOrMultiple(selectors, function (selector) {
    return element.matches(selector);
  });
  return isArray(res) ? res.some(function (t) {
    return t;
  }) : res;
}

export function isSsr() {
  return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
export function hasMatchMedia() {
  return !isSsr() && typeof matchMedia !== "undefined";
}
export function safeMatchMedia(query) {
  if (!hasMatchMedia()) {
    return;
  }

  return matchMedia(query);
}
export function safeMutationObserver(callback) {
  if (isSsr() || typeof MutationObserver === "undefined") {
    return;
  }

  return new MutationObserver(callback);
}
export function isInArray(value, array) {
  return value === array || isArray(array) && array.indexOf(value) > -1;
}
export function loadFont(_x, _x2) {
  return _loadFont.apply(this, arguments);
}

function _loadFont() {
  _loadFont = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(font, weight) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return document.fonts.load("".concat(weight !== null && weight !== void 0 ? weight : "400", " 36px '").concat(font !== null && font !== void 0 ? font : "Verdana", "'"));

          case 3:
            _context.next = 7;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _loadFont.apply(this, arguments);
}

export function arrayRandomIndex(array) {
  return Math.floor(getRandom() * array.length);
}
export function itemFromArray(array, index) {
  var useIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return array[index !== undefined && useIndex ? index % array.length : arrayRandomIndex(array)];
}
export function isPointInside(point, size, offset, radius, direction) {
  return areBoundsInside(calculateBounds(point, radius !== null && radius !== void 0 ? radius : 0), size, offset, direction);
}
export function areBoundsInside(bounds, size, offset, direction) {
  var inside = true;

  if (!direction || direction === "bottom") {
    inside = bounds.top < size.height + offset.x;
  }

  if (inside && (!direction || direction === "left")) {
    inside = bounds.right > offset.x;
  }

  if (inside && (!direction || direction === "right")) {
    inside = bounds.left < size.width + offset.y;
  }

  if (inside && (!direction || direction === "top")) {
    inside = bounds.bottom > offset.y;
  }

  return inside;
}
export function calculateBounds(point, radius) {
  return {
    bottom: point.y + radius,
    left: point.x - radius,
    right: point.x + radius,
    top: point.y - radius
  };
}
export function deepExtend(destination) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];

    if (source === undefined || source === null) {
      continue;
    }

    if (!isObject(source)) {
      destination = source;
      continue;
    }

    var sourceIsArray = Array.isArray(source);

    if (sourceIsArray && (isObject(destination) || !destination || !Array.isArray(destination))) {
      destination = [];
    } else if (!sourceIsArray && (isObject(destination) || !destination || Array.isArray(destination))) {
      destination = {};
    }

    var _loop = function _loop(key) {
      if (key === "__proto__") {
        return "continue";
      }

      var sourceDict = source,
          value = sourceDict[key],
          destDict = destination;
      destDict[key] = isObject(value) && Array.isArray(value) ? value.map(function (v) {
        return deepExtend(destDict[key], v);
      }) : deepExtend(destDict[key], value);
    };

    for (var key in source) {
      var _ret = _loop(key);

      if (_ret === "continue") continue;
    }
  }

  return destination;
}
export function isDivModeEnabled(mode, divs) {
  return !!findItemFromSingleOrMultiple(divs, function (t) {
    return t.enable && isInArray(mode, t.mode);
  });
}
export function divModeExecute(mode, divs, callback) {
  executeOnSingleOrMultiple(divs, function (div) {
    var divMode = div.mode,
        divEnabled = div.enable;

    if (divEnabled && isInArray(mode, divMode)) {
      singleDivModeExecute(div, callback);
    }
  });
}
export function singleDivModeExecute(div, callback) {
  var selectors = div.selectors;
  executeOnSingleOrMultiple(selectors, function (selector) {
    callback(selector, div);
  });
}
export function divMode(divs, element) {
  if (!element || !divs) {
    return;
  }

  return findItemFromSingleOrMultiple(divs, function (div) {
    return checkSelector(element, div.selectors);
  });
}
export function circleBounceDataFromParticle(p) {
  return {
    position: p.getPosition(),
    radius: p.getRadius(),
    mass: p.getMass(),
    velocity: p.velocity,
    factor: Vector.create(getValue(p.options.bounce.horizontal), getValue(p.options.bounce.vertical))
  };
}
export function circleBounce(p1, p2) {
  var _p1$velocity$sub = p1.velocity.sub(p2.velocity),
      xVelocityDiff = _p1$velocity$sub.x,
      yVelocityDiff = _p1$velocity$sub.y,
      _ref = [p1.position, p2.position],
      pos1 = _ref[0],
      pos2 = _ref[1],
      _getDistances = getDistances(pos2, pos1),
      xDist = _getDistances.dx,
      yDist = _getDistances.dy;

  if (xVelocityDiff * xDist + yVelocityDiff * yDist < 0) {
    return;
  }

  var angle = -Math.atan2(yDist, xDist),
      m1 = p1.mass,
      m2 = p2.mass,
      u1 = p1.velocity.rotate(angle),
      u2 = p2.velocity.rotate(angle),
      v1 = collisionVelocity(u1, u2, m1, m2),
      v2 = collisionVelocity(u2, u1, m1, m2),
      vFinal1 = v1.rotate(-angle),
      vFinal2 = v2.rotate(-angle);
  p1.velocity.x = vFinal1.x * p1.factor.x;
  p1.velocity.y = vFinal1.y * p1.factor.y;
  p2.velocity.x = vFinal2.x * p2.factor.x;
  p2.velocity.y = vFinal2.y * p2.factor.y;
}
export function rectBounce(particle, divBounds) {
  var pPos = particle.getPosition(),
      size = particle.getRadius(),
      bounds = calculateBounds(pPos, size),
      resH = rectSideBounce({
    pSide: {
      min: bounds.left,
      max: bounds.right
    },
    pOtherSide: {
      min: bounds.top,
      max: bounds.bottom
    },
    rectSide: {
      min: divBounds.left,
      max: divBounds.right
    },
    rectOtherSide: {
      min: divBounds.top,
      max: divBounds.bottom
    },
    velocity: particle.velocity.x,
    factor: getValue(particle.options.bounce.horizontal)
  });

  if (resH.bounced) {
    if (resH.velocity !== undefined) {
      particle.velocity.x = resH.velocity;
    }

    if (resH.position !== undefined) {
      particle.position.x = resH.position;
    }
  }

  var resV = rectSideBounce({
    pSide: {
      min: bounds.top,
      max: bounds.bottom
    },
    pOtherSide: {
      min: bounds.left,
      max: bounds.right
    },
    rectSide: {
      min: divBounds.top,
      max: divBounds.bottom
    },
    rectOtherSide: {
      min: divBounds.left,
      max: divBounds.right
    },
    velocity: particle.velocity.y,
    factor: getValue(particle.options.bounce.vertical)
  });

  if (resV.bounced) {
    if (resV.velocity !== undefined) {
      particle.velocity.y = resV.velocity;
    }

    if (resV.position !== undefined) {
      particle.position.y = resV.position;
    }
  }
}
export function executeOnSingleOrMultiple(obj, callback) {
  return isArray(obj) ? obj.map(function (item, index) {
    return callback(item, index);
  }) : callback(obj, 0);
}
export function itemFromSingleOrMultiple(obj, index, useIndex) {
  return isArray(obj) ? itemFromArray(obj, index, useIndex) : obj;
}
export function findItemFromSingleOrMultiple(obj, callback) {
  return isArray(obj) ? obj.find(function (t, index) {
    return callback(t, index);
  }) : callback(obj, 0) ? obj : undefined;
}
export function initParticleNumericAnimationValue(options, pxRatio) {
  var valueRange = options.value,
      animationOptions = options.animation,
      res = {
    delayTime: getRangeValue(animationOptions.delay) * 1000,
    enable: animationOptions.enable,
    value: getRangeValue(options.value) * pxRatio,
    max: getRangeMax(valueRange) * pxRatio,
    min: getRangeMin(valueRange) * pxRatio,
    loops: 0,
    maxLoops: getRangeValue(animationOptions.count),
    time: 0
  };

  if (animationOptions.enable) {
    res.decay = 1 - getRangeValue(animationOptions.decay);

    switch (animationOptions.mode) {
      case "increase":
        res.status = "increasing";
        break;

      case "decrease":
        res.status = "decreasing";
        break;

      case "random":
        res.status = getRandom() >= 0.5 ? "increasing" : "decreasing";
        break;
    }

    var autoStatus = animationOptions.mode === "auto";

    switch (animationOptions.startValue) {
      case "min":
        res.value = res.min;

        if (autoStatus) {
          res.status = "increasing";
        }

        break;

      case "max":
        res.value = res.max;

        if (autoStatus) {
          res.status = "decreasing";
        }

        break;

      case "random":
      default:
        res.value = randomInRange(res);

        if (autoStatus) {
          res.status = getRandom() >= 0.5 ? "increasing" : "decreasing";
        }

        break;
    }
  }

  res.initialValue = res.value;
  return res;
}

function getPositionOrSize(positionOrSize, canvasSize) {
  var isPercent = positionOrSize.mode === "percent";

  if (!isPercent) {
    var _ = positionOrSize.mode,
        rest = _objectWithoutProperties(positionOrSize, _excluded);

    return rest;
  }

  var isPosition = ("x" in positionOrSize);

  if (isPosition) {
    return {
      x: positionOrSize.x / 100 * canvasSize.width,
      y: positionOrSize.y / 100 * canvasSize.height
    };
  } else {
    return {
      width: positionOrSize.width / 100 * canvasSize.width,
      height: positionOrSize.height / 100 * canvasSize.height
    };
  }
}

export function getPosition(position, canvasSize) {
  return getPositionOrSize(position, canvasSize);
}
export function getSize(size, canvasSize) {
  return getPositionOrSize(size, canvasSize);
}
export function isBoolean(arg) {
  return typeof arg === "boolean";
}
export function isString(arg) {
  return typeof arg === "string";
}
export function isNumber(arg) {
  return typeof arg === "number";
}
export function isFunction(arg) {
  return typeof arg === "function";
}
export function isObject(arg) {
  return typeof arg === "object" && arg !== null;
}
export function isArray(arg) {
  return Array.isArray(arg);
}